import { AlertTriangle, FileText, ScanLine } from "lucide-react";
import EmptyState from "../common/EmptyState";
import { t, tc } from "../../i18n/index.js";
import type { KbDocument } from "../../types/index.js";

export function chunkCount(document: KbDocument) {
  return Array.isArray(document.chunks) ? document.chunks.length : Number(document.chunks || 0);
}

export function firstExcerpt(document: KbDocument, limit = 220) {
  const chunk = (document.excerptChunks || [])[0];
  const text = (typeof chunk === "string" ? chunk : chunk?.text || "").replace(/\s+/g, " ").trim();
  return text.length > limit ? `${text.slice(0, limit)}…` : text;
}

export default function DocumentTable({ documents, onOpen }: {
  documents: KbDocument[]; onOpen: (id: string) => void;
}) {
  if (!documents.length) {
    return <EmptyState icon={<FileText size={22} />} title={t("admin.kb.empty.title")} body={t("admin.kb.empty.body")} />;
  }
  const columns = ["document", "category", "origin", "chunks", "status", "indexedAt"];

  return <section className="admin-table">
    <table>
      <thead><tr>{columns.map(key => <th key={key} scope="col">{t(`admin.kb.th.${key}`)}</th>)}</tr></thead>
      <tbody>
        {documents.map(document => <tr key={document.id} className="admin-row"
          tabIndex={0} role="link"
          onClick={() => onOpen(document.id)}
          onKeyDown={event => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); onOpen(document.id); } }}>
          <td>
            <strong>{document.name}</strong>
            <em>{firstExcerpt(document)}</em>
          </td>
          <td><span className="kb-pill">{tc(`docCategory.${document.category}`, document.category)}</span></td>
          <td>{tc(`orgUnit.${document.origin}`, document.origin)}</td>
          <td>{chunkCount(document)}</td>
          <td className="kb-status-cell">
            <span className={document.status === "indexed" ? "ok-pill" : "ko-pill"}>
              {document.status === "indexed" ? null : <ScanLine size={12} aria-hidden="true" />}
              {tc(`docStatus.${document.status}`, document.status)}
            </span>
            {document.exceedsDraftLimit && <span className="warn-pill">
              <AlertTriangle size={12} aria-hidden="true" />{t("admin.kb.overDraftLimit")}
            </span>}
          </td>
          <td>{new Date(document.uploadedAt).toLocaleDateString("fr-FR")}</td>
        </tr>)}
      </tbody>
    </table>
  </section>;
}
